// Hide the cursor by default; reveal for `CURSOR_VISIBLE_MS` on every mouse
// movement. Kiosk displays have no need for a visible pointer 99% of the
// time, but operators occasionally interact during setup — fading it in/out
// keeps the screen clean without trapping them.
//
// Bound at module-load time from main.tsx via `installCursorAutoHide()`.

const CURSOR_VISIBLE_MS = 3_000

export function installCursorAutoHide(): void {
  if (typeof document === 'undefined') return
  // Start hidden; CSS in index.css sets `body { cursor: none }`. Adding the
  // class lifts the rule for the next CURSOR_VISIBLE_MS window.
  let timer: number | null = null

  const reveal = () => {
    document.body.classList.add('cursor-visible')
    if (timer !== null) window.clearTimeout(timer)
    timer = window.setTimeout(() => {
      document.body.classList.remove('cursor-visible')
      timer = null
    }, CURSOR_VISIBLE_MS)
  }

  window.addEventListener('mousemove', reveal, { passive: true })
  window.addEventListener('touchstart', reveal, { passive: true })
}
